"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultsDark = exports.defaults = exports.patterns = exports.scatterplotDefaultsDark = exports.scatterplotDefaults = exports.bulletDefaultsDark = exports.bulletDefaults = exports.barDefaultsDark = exports.barDefaults = exports.heatmapDefaultsDark = exports.heatmapDefaults = exports.pieDefaultsDark = exports.pieDefaults = exports.lineDefaultsDark = exports.lineDefaults = exports.themeDark = exports.theme = void 0;
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var palette_1 = require("./palette");
var typography_1 = require("./typography");
var colors_1 = require("./colors");
var shape_1 = require("./shape");
var spacing_1 = require("./spacing");
exports.theme = {
    background: palette_1.palette.common.transparent.hex,
    fontFamily: typography_1.typography.font.family.sansSerif,
    fontSize: parseFloat(typography_1.typography.textStyles.micro.fontSize) * 16,
    textColor: palette_1.palette.text.primary.hex,
    axis: {
        domain: {
            line: {
                stroke: palette_1.palette.common.transparent.hex,
                strokeWidth: 1,
            },
        },
        ticks: {
            line: {
                stroke: palette_1.palette.border.dark.hex,
                strokeWidth: 1,
            },
            text: {},
        },
        legend: {
            text: {
                fontSize: parseFloat(typography_1.typography.textStyles.normal.fontSize) * 16,
                fontWeight: typography_1.typography.font.weight.bold,
            },
        },
    },
    grid: {
        line: {
            stroke: palette_1.palette.border.default.hex,
            strokeWidth: 1,
        },
    },
    legends: {
        hidden: {
            symbol: {
                fill: colors_1.color.N9.hex,
                opacity: 0.6,
            },
            text: {
                fill: colors_1.color.N9.hex,
                opacity: 0.6,
            },
        },
        text: {
            fill: colors_1.color.N10.hex,
        },
    },
    labels: {
        text: {
            fontSize: parseFloat(typography_1.typography.textStyles.small.fontSize) * 16,
        },
    },
    markers: {
        lineColor: palette_1.palette.common.black.hex,
        lineStrokeWidth: 1,
        text: {},
    },
    dots: {
        text: {},
    },
    tooltip: {
        container: {
            background: palette_1.palette.background.light.hex,
            color: 'inherit',
            fontSize: 'inherit',
            borderRadius: shape_1.shape.borderRadius.default,
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
            padding: "".concat(spacing_1.spacing.xs2, " ").concat(spacing_1.spacing.xs),
        },
        basic: {
            whiteSpace: 'pre',
            display: 'flex',
            alignItems: 'center',
        },
        chip: {
            marginRight: spacing_1.spacing.xs.getValue(),
        },
        table: {},
        tableCell: {
            padding: '3px 5px',
        },
        tableCellValue: {
            fontWeight: typography_1.typography.font.weight.bold,
        },
    },
    crosshair: {
        line: {
            stroke: palette_1.palette.common.black.hex,
            strokeWidth: 1,
            strokeOpacity: 0.75,
            strokeDasharray: '6 6',
        },
    },
    annotations: {
        text: {
            fontSize: parseFloat(typography_1.typography.textStyles.small.fontSize) * 16,
            outlineWidth: 2,
            outlineColor: palette_1.palette.common.white.hex,
        },
        link: {
            stroke: palette_1.palette.common.black.hex,
            strokeWidth: 1,
            outlineWidth: 2,
            outlineColor: palette_1.palette.common.white.hex,
        },
        outline: {
            fill: 'none',
            stroke: palette_1.palette.common.black.hex,
            strokeWidth: 2,
            outlineWidth: 2,
            outlineColor: palette_1.palette.common.white.hex,
        },
        symbol: {
            fill: palette_1.palette.common.black.hex,
            outlineWidth: 2,
            outlineColor: palette_1.palette.common.white.hex,
        },
    },
};
exports.themeDark = (0, lodash_merge_1.default)({}, exports.theme, {
    textColor: palette_1.palette.text.contrast.hex,
    axis: {
        ticks: {
            line: {
                opacity: 0.15,
            },
        },
    },
    grid: {
        line: {
            opacity: 0.15,
        },
    },
    legends: {
        hidden: {
            symbol: {
                fill: colors_1.color.N3.hex,
                opacity: 0.6,
            },
            text: {
                fill: colors_1.color.N3.hex,
                opacity: 0.6,
            },
        },
        text: {
            fill: colors_1.color.N2.hex,
        },
    },
    markers: {
        lineColor: palette_1.palette.common.white.hex,
    },
    crosshair: {
        line: {
            stroke: palette_1.palette.common.white.hex,
        },
    },
    annotations: {
        text: {
            outlineColor: palette_1.palette.common.black.hex,
        },
        link: {
            stroke: palette_1.palette.common.white.hex,
            outlineColor: palette_1.palette.common.black.hex,
        },
        outline: {
            stroke: palette_1.palette.common.white.hex,
            outlineColor: palette_1.palette.common.black.hex,
        },
        symbol: {
            fill: palette_1.palette.common.white.hex,
            outlineColor: palette_1.palette.common.black.hex,
        },
    },
});
// these are used by more than 1 component
var generalDefaults = {
    useMesh: true,
    lightColorHexes: (0, colors_1.colorMapToHexVals)(colors_1.lightCategoricalColor),
    darkColorHexes: (0, colors_1.colorMapToHexVals)(colors_1.darkCategoricalColor),
    lightValueLabelColor: palette_1.palette.text.contrast.hex,
    darkValueLabelColor: palette_1.palette.text.primary.hex,
};
// defaults for specific components
exports.lineDefaults = {
    theme: exports.theme,
    lineWidth: 4,
    pointSize: 8,
    curve: 'natural',
    useMesh: generalDefaults.useMesh,
    colors: generalDefaults.lightColorHexes,
};
exports.lineDefaultsDark = (0, lodash_merge_1.default)({}, exports.lineDefaults, {
    theme: exports.themeDark,
    colors: generalDefaults.darkColorHexes,
});
exports.pieDefaults = {
    theme: exports.theme,
    innerRadius: 0.5,
    padAngle: 1.5,
    cornerRadius: parseFloat(shape_1.shape.borderRadius.default),
    activeOuterRadiusOffset: spacing_1.spacing.xs.getValue(),
    arcLinkLabelsSkipAngle: 10,
    arcLinkLabelsThickness: 2,
    arcLabelsSkipAngle: 25,
    arcLinkLabelsColor: {
        from: 'color',
    },
    arcLabelsTextColor: generalDefaults.lightValueLabelColor,
    colors: generalDefaults.lightColorHexes,
};
exports.pieDefaultsDark = (0, lodash_merge_1.default)({}, exports.pieDefaults, {
    theme: exports.themeDark,
    colors: generalDefaults.darkColorHexes,
    arcLabelsTextColor: generalDefaults.darkValueLabelColor,
});
exports.heatmapDefaults = {
    theme: exports.theme,
    padding: 2,
    labelTextColor: generalDefaults.lightValueLabelColor,
    hoverTarget: 'cell',
    colors: (0, colors_1.colorsIdsToHexVals)(['B6', 'B7', 'B8', 'B9', 'B10']),
};
exports.heatmapDefaultsDark = (0, lodash_merge_1.default)({}, exports.heatmapDefaults, {
    theme: exports.themeDark,
    labelTextColor: generalDefaults.darkValueLabelColor,
    colors: (0, colors_1.colorsIdsToHexVals)(['B1', 'B2', 'B3', 'B4', 'B5']),
});
exports.barDefaults = {
    theme: exports.theme,
    padding: 0.3,
    borderColor: {
        from: 'color',
        modifiers: [['darker', 1.6]],
    },
    labelSkipWidth: 12,
    labelSkipHeight: 15,
    labelTextColor: generalDefaults.lightValueLabelColor,
    colors: generalDefaults.lightColorHexes,
};
exports.barDefaultsDark = (0, lodash_merge_1.default)({}, exports.barDefaults, {
    theme: exports.themeDark,
    borderColor: {
        from: 'color',
        modifiers: [['brighter', 1.6]],
    },
    colors: generalDefaults.darkColorHexes,
    labelTextColor: generalDefaults.darkValueLabelColor,
});
exports.bulletDefaults = {
    theme: exports.theme,
    titleOffsetX: -spacing_1.spacing.sm.getValue(),
    markerSize: 1.6,
    measureSize: 0.3,
    titleAlign: 'end',
    rangeColors: (0, colors_1.colorsIdsToHexVals)(['N4', 'N5', 'N6', 'N7', 'N8', 'N9']),
    measureColors: (0, colors_1.colorsIdsToHexVals)(['B5', 'B6', 'B7', 'B8']),
    markerColors: (0, colors_1.colorsIdsToHexVals)(['G6', 'G7', 'G9', 'G10']),
};
exports.bulletDefaultsDark = (0, lodash_merge_1.default)({}, exports.bulletDefaults, {
    theme: exports.themeDark,
});
exports.scatterplotDefaults = {
    theme: exports.theme,
    nodeSize: 12,
    useMesh: generalDefaults.useMesh,
    blendMode: 'multiply',
    colors: generalDefaults.lightColorHexes,
};
exports.scatterplotDefaultsDark = (0, lodash_merge_1.default)({}, exports.scatterplotDefaults, {
    theme: exports.themeDark,
    blendMode: 'normal',
    colors: generalDefaults.darkColorHexes,
});
exports.patterns = {
    dots: {
        id: 'dots',
        type: 'patternDots',
        size: 2,
        padding: 2,
        stagger: false,
        background: colors_1.color.transparent.hex,
        color: 'inherit',
    },
    lines: {
        id: 'lines',
        type: 'patternLines',
        spacing: 5,
        rotation: 45,
        lineWidth: 2,
        background: colors_1.color.transparent.hex,
        color: 'inherit',
    },
    squares: {
        id: 'squares',
        type: 'patternSquares',
        size: 4,
        padding: 4,
        stagger: false,
        background: colors_1.color.transparent.hex,
        color: 'inherit',
    },
    dots2: {
        id: 'dots2',
        type: 'patternDots',
        size: 4,
        padding: 1,
        stagger: true,
        background: colors_1.color.transparent.hex,
        color: 'inherit',
    },
    lines2: {
        id: 'lines2',
        type: 'patternLines',
        rotation: -45,
        lineWidth: 6,
        spacing: 10,
        background: colors_1.color.transparent.hex,
        color: 'inherit',
    },
    squares2: {
        id: 'squares2',
        type: 'patternSquares',
        size: 6,
        padding: 1,
        stagger: true,
        background: colors_1.color.transparent.hex,
        color: 'inherit',
    },
    solid: {
        id: 'solid',
        type: 'patternDots',
        size: 1,
        padding: 0,
        stagger: false,
        background: colors_1.color.transparent.hex,
        color: 'inherit',
    },
    gray: {
        id: 'gray',
        type: 'patternDots',
        size: 1,
        padding: 1,
        stagger: false,
        background: colors_1.color.transparent.hex,
        color: 'inherit',
    },
};
// combined theme and component defaults
exports.defaults = __assign(__assign(__assign(__assign(__assign(__assign({}, exports.lineDefaults), exports.pieDefaults), exports.heatmapDefaults), exports.barDefaults), exports.bulletDefaults), exports.scatterplotDefaults);
exports.defaultsDark = __assign(__assign(__assign(__assign(__assign(__assign({}, exports.lineDefaultsDark), exports.pieDefaultsDark), exports.heatmapDefaultsDark), exports.barDefaultsDark), exports.bulletDefaultsDark), exports.scatterplotDefaultsDark);
//# sourceMappingURL=nivo.js.map